import Button from '../../../../components/button/button';
import Translate from '../../../../components/translate/translate';
import { h } from 'preact';
import { PostRatingArgs } from '../rating-form';

interface RatingFooterProps {
	onSubmit: (postRatingArgs: PostRatingArgs) => void;
	onSkip: () => void;
}

const RatingFormFooter = ({ onSubmit, onSkip }: RatingFooterProps) => {
	return (
		<div className="rating-form-footer">
			<Button className="rate-us-button" onClick={onSubmit} testId="submit" name="submit-button">
				<Translate text="SCHEDULE.RATE_US" />
			</Button>
			<div className="skip-button" onClick={onSkip} data-testid="skip">
				<Translate text="RATING.SKIP" />
			</div>
		</div>
	);
};

export default RatingFormFooter;
